var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "media-grid-wrap" },
    [
      _c("div", { staticClass: "media-layout" }, [
        _c(
          "div",
          { staticClass: "group-sidebar" },
          [
            _c(
              "div",
              {
                staticClass: "group-item",
                class: { active: !_vm.recycleBin && _vm.activeGroup === "" },
                on: {
                  click: function ($event) {
                    return _vm.selectGroup("")
                  },
                },
              },
              [
                _c("a-icon", { attrs: { type: "appstore" } }),
                _c("span", { staticClass: "group-name" }, [_vm._v("全部")]),
              ],
              1
            ),
            _vm._l(_vm.groups, function (g) {
              return _c(
                "div",
                {
                  key: g.id,
                  staticClass: "group-item",
                  class: {
                    active:
                      !_vm.recycleBin &&
                      String(_vm.activeGroup) === String(g.id),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.selectGroup(g.id)
                    },
                  },
                },
                [
                  _c("a-icon", { attrs: { type: "folder" } }),
                  _c(
                    "span",
                    { staticClass: "group-name", attrs: { title: g.name } },
                    [_vm._v(_vm._s(g.name))]
                  ),
                  _c("span", { staticClass: "group-count" }, [
                    _vm._v(_vm._s(g.count)),
                  ]),
                  !_vm.selectable
                    ? _c("a-icon", {
                        staticClass: "group-del",
                        attrs: { type: "close" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.removeGroup(g)
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            }),
            _c(
              "div",
              {
                staticClass: "group-item add",
                on: {
                  click: function ($event) {
                    _vm.groupModal.visible = true
                  },
                },
              },
              [
                _c("a-icon", { attrs: { type: "folder-add" } }),
                _c("span", { staticClass: "group-name" }, [_vm._v("新建分组")]),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "group-item recycle-entry",
                class: { active: _vm.recycleBin },
                on: { click: _vm.selectRecycleBin },
              },
              [
                _c("a-icon", { attrs: { type: "delete" } }),
                _c("span", { staticClass: "group-name" }, [_vm._v("回收站")]),
              ],
              1
            ),
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "main-area" },
          [
            _c(
              "div",
              { staticClass: "media-toolbar" },
              [
                _c("a-input-search", {
                  staticStyle: { width: "240px" },
                  attrs: { placeholder: "请输入图片名称", "allow-clear": "" },
                  on: { search: _vm.onSearch },
                  model: {
                    value: _vm.keyword,
                    callback: function ($$v) {
                      _vm.keyword = $$v
                    },
                    expression: "keyword",
                  },
                }),
                !_vm.recycleBin
                  ? [
                      _c(
                        "a-upload",
                        {
                          attrs: {
                            multiple: true,
                            "show-upload-list": false,
                            accept: "image/*",
                            "before-upload": _vm.handleUpload,
                          },
                        },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "upload",
                                loading: _vm.uploading,
                              },
                            },
                            [_vm._v("上传图片")]
                          ),
                        ],
                        1
                      ),
                      !_vm.selectable
                        ? _c(
                            "a-button",
                            {
                              attrs: {
                                icon: "drag",
                                disabled: !_vm.selectedIds.length,
                              },
                              on: { click: _vm.openMoveModal },
                            },
                            [_vm._v("移动图片")]
                          )
                        : _vm._e(),
                      !_vm.selectable
                        ? _c(
                            "a-button",
                            {
                              attrs: {
                                icon: "delete",
                                disabled: !_vm.selectedIds.length,
                              },
                              on: { click: _vm.batchRemove },
                            },
                            [_vm._v("批量删除")]
                          )
                        : _vm._e(),
                    ]
                  : _vm._e(),
                _vm.recycleBin
                  ? _c(
                      "a-button",
                      {
                        attrs: {
                          type: "danger",
                          icon: "clear",
                          disabled: !_vm.total,
                        },
                        on: { click: _vm.emptyRecycleBin },
                      },
                      [_vm._v("清空回收站")]
                    )
                  : _vm._e(),
              ],
              2
            ),
            _c(
              "a-spin",
              { attrs: { spinning: _vm.loading } },
              [
                _vm.rows.length
                  ? _c(
                      "div",
                      { staticClass: "pic-grid" },
                      _vm._l(_vm.rows, function (item) {
                        return _c(
                          "div",
                          {
                            key: item.id,
                            staticClass: "pic-card",
                            class: {
                              selected:
                                _vm.selectable &&
                                _vm.selectedIds.indexOf(item.id) > -1,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "pic-thumb",
                                on: {
                                  click: function ($event) {
                                    return _vm.onPicClick(item)
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: _vm.imgUrl(item.url),
                                    alt: item.name,
                                  },
                                }),
                                !_vm.selectable
                                  ? _c("a-icon", {
                                      staticClass: "pic-del",
                                      attrs: { type: "close-circle" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.removeOne(item)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm.selectable &&
                                _vm.selectedIds.indexOf(item.id) > -1
                                  ? _c(
                                      "span",
                                      { staticClass: "pic-check" },
                                      [
                                        _c("a-icon", {
                                          attrs: { type: "check" },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "pic-name",
                                attrs: { title: item.name },
                              },
                              [_vm._v(_vm._s(item.name))]
                            ),
                            _vm.recycleBin
                              ? _c(
                                  "div",
                                  { staticClass: "pic-actions" },
                                  [
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.restoreOne(item)
                                          },
                                        },
                                      },
                                      [_vm._v("恢复")]
                                    ),
                                    _c("a-divider", {
                                      attrs: { type: "vertical" },
                                    }),
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.purgeOne(item)
                                          },
                                        },
                                      },
                                      [_vm._v("彻底删除")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    )
                  : _c("a-empty", {
                      staticStyle: { "margin-top": "60px" },
                      attrs: {
                        description: _vm.recycleBin
                          ? "回收站为空"
                          : "暂无图片，请上传",
                      },
                    }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "media-pagination" },
              [
                _c("a-pagination", {
                  attrs: {
                    current: _vm.page,
                    "page-size": _vm.pageSize,
                    total: _vm.total,
                    "show-total": (t) => `共 ${t} 张`,
                  },
                  on: { change: _vm.onPageChange },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.groupModal.visible,
            title: "新建分组",
            "ok-text": "确定",
            "cancel-text": "取消",
            "confirm-loading": _vm.groupModal.saving,
          },
          on: {
            ok: _vm.createGroup,
            cancel: function ($event) {
              _vm.groupModal.visible = false
            },
          },
        },
        [
          _c("a-input", {
            attrs: { placeholder: "请输入分组名称", maxLength: 20 },
            on: { pressEnter: _vm.createGroup },
            model: {
              value: _vm.groupModal.name,
              callback: function ($$v) {
                _vm.$set(_vm.groupModal, "name", $$v)
              },
              expression: "groupModal.name",
            },
          }),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.moveModal.visible,
            title: "移动图片",
            "ok-text": "确定",
            "cancel-text": "取消",
            "confirm-loading": _vm.moveModal.saving,
          },
          on: {
            ok: _vm.moveSelected,
            cancel: function ($event) {
              _vm.moveModal.visible = false
            },
          },
        },
        [
          _c(
            "a-radio-group",
            {
              staticClass: "move-group-list",
              model: {
                value: _vm.moveModal.targetGroupId,
                callback: function ($$v) {
                  _vm.$set(_vm.moveModal, "targetGroupId", $$v)
                },
                expression: "moveModal.targetGroupId",
              },
            },
            [
              _c("a-radio", { attrs: { value: 0 } }, [_vm._v("未分组")]),
              _vm._l(_vm.groups, function (g) {
                return _c("a-radio", { key: g.id, attrs: { value: g.id } }, [
                  _vm._v(_vm._s(g.name)),
                ])
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }